import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { SelectedWork } from "@/components/SelectedWork";
import { FlyerStrip } from "@/components/FlyerStrip";
import { Expertise } from "@/components/Expertise";
import { EditMenu } from "@/components/EditMenu";
import { About } from "@/components/About";
import { Credibility } from "@/components/Credibility";
import { Inquiry } from "@/components/Inquiry";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main>
      <Nav />
      <Hero />
      <Marquee />
      <SelectedWork />
      <FlyerStrip />
      <Expertise />
      <EditMenu />
      <About />
      <Credibility />
      <Inquiry />
      <Footer />
    </main>
  );
}
